import styled, { css } from 'styled-components'
import { device } from 'components/Variable'

export const CartStyle = styled.div`
	background-color: ${({ theme }) => theme.color.secondary};
	width: 100%;
	max-height: 0;
	overflow: hidden;
	position: relative;
	transition: max-height 0.5s;
	z-index: 10;
	/*@media (${device.tablet}) {
		color: ${({ theme }) => theme.color.secondary};
		background-color: ${({ theme }) => theme.color.blackOne};
	}*/
	${(p) =>
		p.isOpen &&
		css`
			max-height: 100vh;
		`}
`
